// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2-H3t","col":"Table_col__3Nvem","fulfillmentStatus":"Table_fulfillmentStatus__3sqLv","emailCol":"Table_emailCol__1u28C"};